import React from 'react'
import ReactDom from 'react-dom/client'
import App from './App'
import {BrowserRouter} from 'react-router-dom'

const root = ReactDom.createRoot(document.getElementById('app'))
root.render(
<BrowserRouter>
<App/>
</BrowserRouter>
)

// 热模块替换
if (module.hot) {
  module.hot.accept('./App', () => {
    root.render(
      <BrowserRouter>
        <App/>
      </BrowserRouter>
    )
  })
}